import React from 'react';

import { Card, Form } from 'antd';
import { useIntl } from 'react-intl';
import { openNotification } from 'utils';
import { useDeleteFormContentMediaMutation, useGetOfferQuery } from 'services';
import { useMediaOfferPermission } from 'hooks';
import { useDispatch } from 'react-redux';
import { fetchError } from 'slices/commonSlice';
import ArticleOrderMediaWrapper from 'components/ArticleOrderMedia/ArticleOrderMediaWrapper';

import MediaTypeIcons from './MediaTypeIcons';
import SectionHeader from './SectionHeader';
import AddMediaContentModal from './MediaContent/AddMediaContentModal';

const AddMediaContent = ({ offerID }) => {
  const { formatMessage } = useIntl();

  // Gönderim formunu iki farklı rol kullanır: YAZAR (statü 22) ve MADDE SORUMLUSU (statü 49).
  // İkisinin satır yetkisi aynı değil — yazar yalnız kendi eklediklerini düzenler, madde sorumlusu
  // tablonun tamamını. Bu ayrımı ekranın kendisi tahmin edemez, yetkinin tek kaynağı hook'tur.
  // `useGetOfferQuery` burada ek istek üretmez: ekranı açan route zaten aynı sorguyu çalıştırıyor,
  // RTK Query aynı argümanda tek istek atar.
  const { data: offer } = useGetOfferQuery(offerID, { skip: !offerID });
  const mediaOfferPermission = useMediaOfferPermission(offer);

  const form = Form.useFormInstance();

  const dispatch = useDispatch();

  const [deleteFormContentMedia] = useDeleteFormContentMediaMutation();

  const media = Form.useWatch('media', form);

  // formdan seçili medya silmek için kullanılır zaten gelen istek de ilgili medya da silinip görüntülenecek bu sadsece anlık silme işleinin görünmesi için yapılan bir yöntem
  const handleSetNotDeletedMediaOnForm = (id) => {
    return form.setFieldsValue({
      media: (media || []).filter((item) => item.id !== id),
    });
  };

  // sadece bir maddeyle bağlı olmayan medya silme işlemi yapılır
  const handleDeleteFormMedia = async (id) => {
    const { error } = await deleteFormContentMedia(id);
    if (error) {
      return dispatch(
        fetchError(
          formatMessage(
            {
              id: 'article.form.fetchError',
            },
            { error: error.status }
          )
        )
      );
    }
    handleSetNotDeletedMediaOnForm(id);
    openNotification({
      message: formatMessage({
        id: 'appModule.actionSuccessfully',
      }),
    });
  };

  return (
    <>
      <h5 className="gx-pb-3 gx-pt-3">Medya Teklifi</h5>
      <Card>
        <MediaTypeIcons />
        <SectionHeader />
        {/**
         * Medya teklifi tablosu. `isSubmitFlow` ile gönderim modunda çalışır: satır tıklaması kararsız
         * `EditMediaContentModal`'ı açar (karar bir inceleme aksiyonudur, gönderim formunda yeri yoktur)
         * ve tablonun kendi "Ekle" butonu basılmaz — bu ekranın kendi ekleme arayüzü zaten var
         * (`MediaTypeIcons` + `AddMediaContentModal`).
         *
         * Düzenleme/silme yetkisi yine tek kaynaktan (`permission`) gelir; böylece madde sorumlusu
         * heyetten gelen satırları da düzenleyebilir, yazar ise yalnız kendi eklediklerini.
         */}
        <ArticleOrderMediaWrapper
          handleDeleteFormMedia={handleDeleteFormMedia}
          offerID={offerID}
          permission={mediaOfferPermission}
          isSubmitFlow
        />
        <AddMediaContentModal />
      </Card>
    </>
  );
};

export default AddMediaContent;
